<div class="tw:w-full tw:flex tw:grow tw:h-full">
  <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:grow">
    <div class="tw:w-full tw:px-[15px] tw:md:w-auto tw:md:flex-1 tw:flex tw:items-center tw:justify-center tw:grow"
      [ngClass]="{'gauge-container-max-width': feedbackDashboardItem.showDashboardTimeSeries || feedbackDashboardItem.showDashboardTimeSeries}">
      <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:justify-center tw:items-center">
        <div class="tw:w-full tw:px-[15px] tw:mt-4 dashboard-heading-container">
          <label class="header-text">{{feedbackDashboardItem.dashboardHeader}}</label>
        </div>
        <div class="tw:w-full tw:px-[15px] tw:flex tw:grow tw:items-center tw:justify-center">
          <!-- circle progress -->
          <gauge-chart [data]="gaugeChartData"></gauge-chart>
        </div>
        @if (feedbackDashboardItem.dashboardScoreMovementText) {
          <div class="tw:w-full tw:px-[15px] tw:flex tw:justify-center tw:items-center"
            style="max-height: 25px;"
            >
                    <div [ngClass]="{'score-positive-movement-icon': feedbackDashboardItem.dashboardScoreMovementPositive, 
                                    'score-negative-movement-icon': !feedbackDashboardItem.dashboardScoreMovementPositive}"></div>
            <label class="score-movement-text">{{feedbackDashboardItem.dashboardScoreMovementText}}</label>
          </div>
        }
      </div>
    </div>
    @if (feedbackDashboardItem.showDashboardTimeSeries || feedbackDashboardItem.showDashboardTimeSeries) {
      <div class="tw:w-full tw:px-[15px] tw:md:w-auto tw:md:flex-1 tw:py-6 tw:flex tw:flex-col">
        @if (feedbackDashboardItem.showDashboardSubScores) {
          <div class="tw:flex tw:flex-wrap tw:-mx-[15px]">
            @for (score of scoresList; track score) {
              <div [ngClass]="{'tw:flex-1 tw:px-[15px]': feedbackDashboardItem.showDashboardTimeSeries, 'tw:w-full tw:px-[15px]': !feedbackDashboardItem.showDashboardTimeSeries}">
                <!-- progress bar -->
                <horizontal-fulfillment-gauge [data]="score"></horizontal-fulfillment-gauge>
              </div>
            }
          </div>
        }
        @if (feedbackDashboardItem.showDashboardTimeSeries) {
          <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:grow">
                <div class="tw:flex-1 tw:px-[15px]" [ngClass]="{'line-chart-container-full': !feedbackDashboardItem.showDashboardSubScores,
                                            'line-chart-container-fill': feedbackDashboardItem.showDashboardSubScores}">
              <!-- line chart -->
              <line-chart [data]="lineChartData"></line-chart>
            </div>
          </div>
        }
      </div>
    }
    @if (feedbackDashboardItem.feedbackAdditionalQuestionScoreData) {
      <div class="tw:w-full tw:px-[15px] tw:py-6">
        <div class="tw:flex tw:flex-wrap tw:mx-1 tw:pb-4 additional-question-data-container">
          <div class="tw:w-full tw:px-[15px] tw:mt-4 dashboard-additional-question-heading-container">
            <div class="tw:flex tw:flex-wrap tw:-mx-[15px]">
              <div class="tw:w-full tw:px-[15px] tw:md:w-1/3 tw:text-center tw:sm:text-left">
                <label class="header-text">Follow Up Questions</label>
              </div>
              <div class="tw:w-full tw:px-[15px] tw:md:w-2/3 tw:flex tw:justify-center tw:md:justify-start tw:items-center tw:md:items-start">
                <div class="yes-legend-container">
                  <div class="additional-question-legend-yes-icon"></div>
                  <label class="additional-question-legend-text">Yes</label>
                </div>
                <div class="no-legend-container">
                  <div class="additional-question-legend-no-icon"></div>
                  <label class="additional-question-legend-text">No</label>
                </div>
              </div>
            </div>
          </div>
          @for (item of feedbackDashboardItem.feedbackAdditionalQuestionScoreData; track item) {
<div [ngClass]="{'tw:w-1/4 tw:px-[15px] tw:md:w-1/2 tw:lg:w-1/4': feedbackDashboardItem.showDashboardTimeSeries,
                                'tw:w-1/3 tw:px-[15px] tw:md:w-1/2 tw:lg:w-1/4': !feedbackDashboardItem.showDashboardTimeSeries}"
              >
              <div class="tw:flex tw:flex-wrap tw:-mx-[15px]">
                <div class="tw:w-full tw:px-[15px] tw:text-center">
                  <label>{{item.questionScoreHeaderText}}</label>
                </div>
                <div class="tw:w-full tw:px-[15px]">
                  <doughnut-chart [data]="item.feedbackDataPoints"></doughnut-chart>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>
